/**
 * Dengteli Corporate — Product Card Inquiry CTA Injector
 *
 * Additive DOM injection; zero bundled Liquid/theme-file edits.
 * Targets: homepage featured-collection grid + all collection grids.
 *
 * Insertion logic:
 *  - Find every .card-wrapper that contains a product link (href includes /products/).
 *  - Within that wrapper find the .card__information that is inside the main
 *    .card__content (outer), i.e. the one NOT inside .card__inner.
 *  - Append a <a class="dtl-inquiry-btn"> pointing to the product URL.
 *
 * Idempotent: skip wrappers that already have .dtl-inquiry-btn injected.
 */
(function () {
  'use strict';

  function injectCtas() {
    var wrappers = document.querySelectorAll('.card-wrapper.product-card-wrapper');

    wrappers.forEach(function (wrapper) {
      // Skip placeholder cards (no real product link)
      var productLink = wrapper.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      // Skip if already injected (idempotent)
      if (wrapper.querySelector('.dtl-inquiry-btn')) return;

      var productUrl = productLink.getAttribute('href');

      // Target the outer card__content > card__information
      // (the outer .card__content is a direct child of the .card element,
      //  distinct from the one inside .card__inner which is for the hover overlay)
      var cardEl = wrapper.querySelector('.card');
      if (!cardEl) return;

      // Find all card__content children of the card element (direct children only)
      var outerContent = null;
      var children = cardEl.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i].classList.contains('card__content') &&
            !children[i].closest('.card__inner')) {
          outerContent = children[i];
          break;
        }
      }

      if (!outerContent) {
        // Fallback: try the last card__content inside the wrapper
        var allContents = wrapper.querySelectorAll('.card__content');
        outerContent = allContents[allContents.length - 1] || null;
      }

      if (!outerContent) return;

      var infoDiv = outerContent.querySelector('.card__information');
      if (!infoDiv) return;

      // Build the CTA link
      var btn = document.createElement('a');
      btn.className = 'dtl-inquiry-btn';
      btn.href = productUrl;
      btn.setAttribute('aria-label', 'Send inquiry for ' + (productLink.textContent.trim() || 'this product'));
      btn.textContent = 'Inquiry\u00A0';  // trailing NBSP before the CSS ::after arrow

      infoDiv.appendChild(btn);
    });
  }

  // Run on DOMContentLoaded (covers initial page load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCtas);
  } else {
    injectCtas();
  }

  // Also observe for dynamically loaded cards (e.g. infinite-scroll / filter updates)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var needsRun = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.classList && (n.classList.contains('card-wrapper') || n.classList.contains('product-grid')) ||
            (n.querySelector && n.querySelector('.card-wrapper'))
          );
        });
      });
      if (needsRun) injectCtas();
    });

    document.addEventListener('DOMContentLoaded', function () {
      var mainContent = document.getElementById('MainContent') || document.body;
      observer.observe(mainContent, { childList: true, subtree: true });
    });
  }
})();
